<div class="w-full bg-white border-box radius-10 mb-20" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="" width="40px">
          <div>
            <p class="no-margin light-blue bold">2. Résultats du scrutin à blanc</p>
            <p class="no-margin dark-gray text-sm">Consultez les résultats du scrutin test après ouverture de l'urne.
            </p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

  </div>


  <div class="p-20">
    <div *ngIf="!isValidated" class="p-10 bg-pastel-orange radius-10 flex gap-10 mb-10"
      style="border: solid 1px #FDE68A;">
      <img src="assets/warning-icon.svg" alt="warning icon" width="20px">
      <p class="bold orange no-margin">Scrutin blanc - données de test</p>
    </div>
    <div *ngIf="!isValidated" class="p-10 bg-pastel-orange radius-10" style="border: solid 1px #FDE68A;">
      <p class="bold orange no-margin">En attente du seuil de déscellement</p>
    </div>
    <!-- <v8te-active-button *ngIf="!isValidated" [buttonText]="'Accéder aux résultats'"
      [primaryColor]="'linear-gradient(90deg, #9332EA 0%, #CB9DF5 100%)'" [textPrimaryColor]="'#FFFFFF'"
      [iconPosition]="'left'" [border]="'none'" [icon]="'assets/mail-white.svg'" [iconAlt]="'mail icon'"
      (click)="displayResultEvent.emit()" [height]="'40px'" [minWidth]="'120px'" [width]="'120px'"></v8te-active-button> -->
    <div *ngIf="isValidated && rounds[0].testResults" class="flex flex-column gap-10">
      <div *ngFor="let college of groupedRounds; let i = index">
        <div class="bg-light-gray radius-10 p-20" style="border: solid 1px #DCEEFF">
          <div class="flex content-between">
            <p class="light-blue bold no-margin">Collège {{college.college}}</p>

            <div>
              <button (click)="toggleCollege(college.college)" class="pointer"
                style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
                <span [style.transform]="isExpanded(college.college) ? 'rotate(-90deg)' : 'rotate(90deg)'"
                  style="display: inline-block; transition: transform 0.3s;">›</span>
              </button>
            </div>
          </div>

          <div *ngIf="isExpanded(college.college)" style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px;">
            <div *ngFor="let round of college.rounds; let j = index">
              <div class="radius-10" style="border: solid 1px #E7F4FF;">
                <div [style.background-color]="j != college.rounds.length - 1 ? '#EFF6FF' : '#FFFBEC'" class="p-10 flex gap-10 align-items-center">
                  <img src="assets/silhouette_icon_black.svg" alt="silhouettes">
                  <p class="no-margin dark-blue bold">{{round.title}}</p>
                </div>
                <div class="p-10">
                  <div *ngFor="let list of round.questions[0].answers; let k = index">
                    <p class="no-margin dark-blue grey">
                      <span *ngIf="k != round.questions[0].answers.length - 1">Liste </span>{{list}}
                    </p>

                    <div class="flex gap-10 align-items-center">
                      <progress max="100" value="{{getVotePercentage(round.round, k)}}" style="flex: 1; min-width: 0;"></progress>

                      <div class="text-right" style="flex-shrink: 0;">
                        <p class="no-margin light-blue">{{getFirstTestResult(round.round, k)}} voix</p>
                        <p class="no-margin grey">{{getVotePercentage(round.round, k)}}%</p>
                      </div>
                    </div>

                  </div>
                </div>


              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>